// Pc is defined in app_handler and injected into wbeapp_head_begin_1,
// so we assume it exists before these modules are required. The intent of
// this module is to centralize the window checks, which are needed for
// modules to run on both the client and the server.

let Pc;

if (typeof window !== 'undefined') {
  Pc = window.Pc || {};
} else {
  Pc = global.Pc || {};
}

module.exports = Pc;
